module.exports = {
  realm: 'AU',
  market: 'en-AU',
  domain: 'weightwatchers.com.au',
  countryId: '6000',
  NZcountryId: '6001',
  vsPath: 'au',
  spiceLocale: 'au',
  vsUrl: 'https://www{env}weightwatchers.com/au',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/au/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.com.au/',
  currency: 'A$',
  NZcurrency: 'NZ$',
  decimalSeparator: '.',
  thousandSeparator: ',',
  currencyFormat: 'A$%number',
  NZcurrencyFormat: 'NZ$%number',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.com.au/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.com.au/v2/login/',
  countryCode: 'AU',
  commUlr: 'https://commerce{env}weightwatchers.com/au/en/api/',
  timezone1: 'Australia/Sydney',
  timezone2: '+10:00',
};
